"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _constants = require("../../utils/constants");
var _recoveryMethod = require("../../hooks/recoveryMethod");
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _components = require("./components");
var RemoveRecoveryMethod = function RemoveRecoveryMethod(_ref) {
  var isLoading = _ref.isLoading,
    method = _ref.method,
    onClose = _ref.onClose,
    onRemove = _ref.onRemove,
    warnings = _ref.warnings;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var formatted = (0, _recoveryMethod.useFormattedMethod)(method.value, method.type === _constants.recoveryMethods.phone);
  return /*#__PURE__*/_react["default"].createElement(_components.Layout, {
    title: t("recoveryMethod.remove.".concat(method.type, ".title")),
    subtitle: t("recoveryMethod.remove.".concat(method.type, ".subtitle")),
    actions: /*#__PURE__*/_react["default"].createElement(_components.ButtonGroup, {
      color: "warning",
      onClose: onClose,
      onConfirm: onRemove,
      disabled: !!warnings,
      isLoading: isLoading
    }, t('button.remove'))
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], null, t("settings.recovery.".concat(method.type, ".label"))), /*#__PURE__*/_react["default"].createElement("div", null, formatted), warnings && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, warnings));
};
var _default = exports["default"] = RemoveRecoveryMethod;
//# sourceMappingURL=Remove.js.map